module.exports = __webpack_public_path__ + "img/main_sm.70630466.jpg";